module.exports = __webpack_public_path__ + "static/sri2013-252bdc335010c56a07ab172641010a2d.jpg";